import { render, staticRenderFns } from "./Pildora.vue?vue&type=template&id=093ef025&"
import script from "./Pildora.vue?vue&type=script&lang=js&"
export * from "./Pildora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports